import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, TextField, Table, TableBody, TableCell,
  TableHead, TableRow, Paper, Select, MenuItem, FormControl, InputLabel, Alert, Chip
} from '@mui/material';
import axios from '../api';

const API_URL = '/api/usuarios';

function AdminUsuarios({ usuarioLogado }) {
  const [usuarios, setUsuarios] = useState([]);
  const [form, setForm] = useState({ usuario: '', senha: '', perfil: 'user' });
  const [editId, setEditId] = useState(null);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');

  const fetchUsuarios = async () => {
    const res = await axios.get(API_URL);
    setUsuarios(res.data);
  };

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const resetForm = () => {
    setForm({ usuario: '', senha: '', perfil: 'user' });
    setEditId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setSucesso('');
    try {
      if (editId) {
        const payload = { usuario: form.usuario, perfil: form.perfil };
        if (form.senha) payload.senha = form.senha;
        await axios.put(`${API_URL}/${editId}`, payload);
        setSucesso('Usuário atualizado com sucesso');
      } else {
        await axios.post(API_URL, form);
        setSucesso('Usuário criado com sucesso');
      }
      resetForm();
      fetchUsuarios();
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao salvar usuário');
    }
  };

  const handleEdit = (u) => {
    setForm({ usuario: u.usuario, senha: '', perfil: u.perfil });
    setEditId(u.id);
    setErro('');
    setSucesso('');
  };

  const handleDelete = async (id) => {
    setErro('');
    setSucesso('');
    try {
      await axios.delete(`${API_URL}/${id}`);
      setSucesso('Usuário excluído com sucesso');
      fetchUsuarios();
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao excluir usuário');
    }
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Gestão de Usuários</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Apenas administradores podem cadastrar usuários e definir perfis.
      </Typography>

      {erro && <Alert severity="error" sx={{ mb: 2 }}>{erro}</Alert>}
      {sucesso && <Alert severity="success" sx={{ mb: 2 }}>{sucesso}</Alert>}

      <Paper sx={{ p: 2, mb: 3 }}>
        <Typography variant="h6" gutterBottom>{editId ? 'Editar Usuário' : 'Novo Usuário'}</Typography>
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
            <TextField
              label="Usuário"
              value={form.usuario}
              onChange={e => setForm(prev => ({ ...prev, usuario: e.target.value }))}
              required
              size="small"
            />
            <TextField
              label={editId ? 'Nova senha (opcional)' : 'Senha'}
              type="password"
              value={form.senha}
              onChange={e => setForm(prev => ({ ...prev, senha: e.target.value }))}
              required={!editId}
              size="small"
            />
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel>Perfil</InputLabel>
              <Select
                value={form.perfil}
                label="Perfil"
                onChange={e => setForm(prev => ({ ...prev, perfil: e.target.value }))}
              >
                <MenuItem value="user">User</MenuItem>
                <MenuItem value="admin">Admin</MenuItem>
              </Select>
            </FormControl>
            <Button type="submit" variant="contained" color="primary">
              {editId ? 'Salvar' : 'Cadastrar'}
            </Button>
            {editId && (
              <Button variant="outlined" onClick={resetForm}>Cancelar</Button>
            )}
          </Box>
        </form>
      </Paper>

      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Usuário</TableCell>
              <TableCell>Perfil</TableCell>
              <TableCell align="right">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {usuarios.map(u => (
              <TableRow key={u.id}>
                <TableCell>
                  {u.usuario}
                  {u.usuario === usuarioLogado && (
                    <Chip label="você" size="small" sx={{ ml: 1 }} />
                  )}
                </TableCell>
                <TableCell>
                  <Chip
                    label={u.perfil === 'admin' ? 'Admin' : 'User'}
                    color={u.perfil === 'admin' ? 'primary' : 'default'}
                    size="small"
                  />
                </TableCell>
                <TableCell align="right">
                  <Button size="small" onClick={() => handleEdit(u)} sx={{ mr: 1 }}>Editar</Button>
                  <Button
                    size="small"
                    color="error"
                    onClick={() => handleDelete(u.id)}
                    disabled={u.usuario === usuarioLogado}
                  >
                    Excluir
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}

export default AdminUsuarios;
